// extracted by mini-css-extract-plugin
module.exports = {"name":"columns_name__2GqE8","name__link":"columns_name__link__3jJPa","name__link__name":"columns_name__link__name__2wEvi","name__red":"columns_name__red__2b6Wm"};